<template>
  <v-container
    fluid
    class="maintenance-wrapper d-flex align-center justify-center"
  >
    <v-row justify="center" align="center">
      <v-col cols="12" sm="10" md="7" lg="6">
        <v-card
          class="maintenance-card pa-8 pa-sm-10 text-center"
          rounded="lg"
          elevation="4"
        >
          <div class="logo-wrapper mb-6">
            <v-img
              src="../../assets/img/newLogo.png"
              max-width="150"
              class="mx-auto"
              contain
            ></v-img>
          </div>

          <div class="cog-illustration mb-6">
            <v-icon size="72" color="#218502" class="rotating-cog">
              mdi-cog
            </v-icon>
          </div>

          <h1 class="maintenance-title mb-2">
            <span class="brand-text">HRIS</span> Under Maintenance
          </h1>
          <p class="maintenance-subtitle mb-8">
            We're making some improvements behind the scenes. We'll be back
            shortly.
          </p>

          <v-row justify="center" class="mb-8" no-gutters>
            <v-col
              v-for="(item, i) in countdown"
              :key="i"
              cols="6"
              sm="3"
              class="d-flex justify-center"
            >
              <div class="time-circle">
                <div class="time-value">{{ item.value }}</div>
                <div class="time-label">{{ item.label }}</div>
              </div>
            </v-col>
          </v-row>

          <v-progress-linear
            :value="progress"
            height="14"
            rounded
            color="#218502"
            background-color="#e3f0df"
            class="mb-3"
          >
            <template #default>
              <strong class="progress-text">{{ progress }}%</strong>
            </template>
          </v-progress-linear>
          <p class="progress-status">Estimated completion progress</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Maintenance",

  data() {
    return {
      timer: null,
      now: null,
      startDate: null,
      targetDate: null,
      maintenance: process.env.VUE_APP_MAINTENANCE == "false" ? false : true,
      timeLeft: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    };
  },
  computed: {
    countdown() {
      return [
        { label: "DAYS", value: this.timeLeft.days },
        { label: "HOURS", value: this.timeLeft.hours },
        { label: "MINUTES", value: this.timeLeft.minutes },
        { label: "SECONDS", value: this.timeLeft.seconds },
      ];
    },
    progress() {
      if (!this.startDate || !this.targetDate) return 0;
      const total = this.targetDate - this.startDate;
      const elapsed = this.now - this.startDate;
      return Math.min(100, Math.max(0, Math.round((elapsed / total) * 100)));
    },
  },
  watch: {
    maintenance(isActive) {
      if (isActive) {
        this.now = new Date();
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    },
  },

  methods: {
    startCountdown() {
      const savedTarget = localStorage.getItem("maintenance_target");
      const savedStart = localStorage.getItem("maintenance_start");

      if (!savedTarget || !savedStart) {
        const start = new Date();
        const target = new Date(start);
        // target.setDate(target.getDate() + 12); //days
        target.setHours(target.getHours() + 3); //hours

        localStorage.setItem("maintenance_start", start.toISOString());
        localStorage.setItem("maintenance_target", target.toISOString());

        this.startDate = start;
        this.targetDate = target;
      } else {
        this.startDate = new Date(savedStart);
        this.targetDate = new Date(savedTarget);
      }

      this.updateCountdown();
      this.timer = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },

    stopCountdown() {
      clearInterval(this.timer);
      this.timer = null;
      localStorage.removeItem("maintenance_target");
      localStorage.removeItem("maintenance_start");
    },

    updateCountdown() {
      this.now = new Date();
      const diff = this.targetDate - this.now;

      if (diff <= 0) {
        this.stopCountdown();
        return;
      }

      this.timeLeft.days = Math.floor(diff / (1000 * 60 * 60 * 24));
      this.timeLeft.hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      this.timeLeft.minutes = Math.floor((diff / (1000 * 60)) % 60);
      this.timeLeft.seconds = Math.floor((diff / 1000) % 60);
    },
  },
  mounted() {
    if (this.maintenance) {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.maintenance-wrapper {
  min-height: 100vh;
  background: linear-gradient(160deg, #f4f9f2 0%, #eaf3e7 45%, #f7faf6 100%);
  padding: 24px;
}

.maintenance-card {
  background: #ffffff;
  border: 1px solid #e6efe3;
}

.cog-illustration {
  display: flex;
  justify-content: center;
}

.maintenance-title {
  font-size: 26px;
  font-weight: 600;
  color: #1f2a24;
}

.brand-text {
  color: #218502;
  font-weight: 800;
}

.maintenance-subtitle {
  font-size: 15px;
  color: #6b7770;
  max-width: 420px;
  margin: 0 auto;
}

.time-circle {
  width: 96px;
  height: 96px;
  background: linear-gradient(145deg, #26990a, #1c7002);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(33, 133, 2, 0.25);
  margin: 8px;
}

.time-value {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.time-label {
  font-size: 10px;
  letter-spacing: 1.2px;
  margin-top: 4px;
  opacity: 0.85;
}

.progress-text {
  font-size: 11px;
  color: #ffffff;
}

.progress-status {
  font-size: 12px;
  color: #8a938d;
  margin-bottom: 0;
}

@media (max-width: 600px) {
  .time-circle {
    width: 76px;
    height: 76px;
  }
  .time-value {
    font-size: 20px;
  }
  .maintenance-title {
    font-size: 21px;
  }
}

.rotating-cog {
  animation: spin 2.5s linear infinite;
  transform-origin: center;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
